import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useEffect, useRef, useState } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicFraisService = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();

  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Paiements, tarification et remboursements", link: '/topics/paiement'},
    { label: 'Tarification et frais', link: '/topics/paiement/tarification'},
    { label: topic.title, link: topic.link},
  ]

// <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/competitions`}>des compétitions</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Afin de garantir une expérience optimale sur Wodzone et de couvrir les coûts liés aux produits et services que nous fournissons, 
              <strong>aucun frais de service supplémentaire n’est facturé aux athlètes</strong>. Ces frais sont entièrement pris en charge par Wodzone,
              et vous ne verrez donc <strong>aucun coût supplémentaire ajouté à votre réservation.</strong>
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                La totalité des frais, représentant généralement entre 5 et 6 % + 0,50 €, est automatiquement déduite du montant versé à l'organisateur 
                pour chaque inscription. Les organisateurs appliquant des conditions d'annulation strictes peuvent se voir appliquer des frais 
                légèrement plus élevés.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <p className="help-text">
                La TVA n’est pas applicable sur les frais de service facturés par Wodzone. En effet, ces frais ne sont pas soumis à la TVA et sont 
                donc calculés et facturés hors taxes. Cela signifie que le montant des frais déduits reste net, sans majoration liée à une quelconque taxation.
              </p>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicFraisService